export default __webpack_public_path__ + "static/media/21.34fe0de4.jpg";